import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../prismicio-types';
import { GradientPlate, ValueCard } from './parts';

import styles from './historyCards.module.scss';
import { OptimizedPrismicImage } from '@/components';
import { HistoryIcons } from './assets/HistoryIcons';
import { useVisible } from '@/hooks';

interface HistoryCardsProps {
  data: Simplify<Content.OurHistorySliceDefaultPrimary>;
}
export const HistoryCards = ({ data }: HistoryCardsProps) => {
  const [isVisible, id] = useVisible();

  const secontCardData = data.second_photo_card[0];

  return (
    <article
      className={`${styles.cards} ${isVisible ? styles.isVisible : ''}`}
      id={id}
    >
      <div className={`${styles.card_wrapper} ${styles.flex_column}`}>
        <GradientPlate text={data.first_gradient_plate_text} />
        <ValueCard
          data={data.first_photo_card[0]}
          cardPosition="first"
          isVisible={isVisible}
        />
      </div>
      {secontCardData && (
        <div
          className={`${styles.card_wrapper} ${styles.second_card} ${isVisible ? styles.isVisible : ''}`}
        >
          <OptimizedPrismicImage
            field={secontCardData.image}
            className={styles.second_card_image}
            quality={100}
          />
          <div className={styles.plate}>
            <HistoryIcons icon={secontCardData.plate_icon} />
            <span>{secontCardData.plate_text}</span>
          </div>
        </div>
      )}
      <div
        className={`${styles.card_wrapper} ${styles.flex_column} ${styles.last_card}`}
      >
        <ValueCard
          data={data.third_photo_card[0]}
          cardPosition="last"
          isVisible={isVisible}
        />
        <GradientPlate text={data.second_gradient_plate_text} />
      </div>
    </article>
  );
};
